import { useMemo, type ReactElement } from 'react';
import {
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { parseOccurrencesAlertKey } from '@kirin/api-client/helpers/alerts';
import { AlertOccurrencesModal } from '@/components/grouped-alerts';
import { DataTableUserAlertsContent } from './DataTableUserAlertsTab';
import { getUserOccurrencesFiltersFromSearchParams } from './DataTableUserAlertsTab/utils';

export default function GroupAlertsTab(): ReactElement {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const occurrencesAlertKey = parseOccurrencesAlertKey(params['*']);

  const occurrencesFilters = useMemo(
    () => getUserOccurrencesFiltersFromSearchParams(searchParams),
    [searchParams]
  );

  return (
    <>
      <DataTableUserAlertsContent />
      {occurrencesAlertKey && (
        <AlertOccurrencesModal
          open
          alertKey={occurrencesAlertKey}
          filters={occurrencesFilters}
          onClose={() =>
            navigate({ pathname: '/dashboard/alerts', search: location.search })
          }
        />
      )}
    </>
  );
}
